__turbopack_context__.v({
  "sectorLabel": "sector-module-scss-module__J2Z5LG__sectorLabel",
});
